import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import AppSearch from './UI.AppSearch';
import AppList from './UI.AppList';
import AppPages from './UI.AppPages';
import { Urls } from 'kts-platform-frame/entry/constant';
import { Spin } from 'antd';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    loadingUrls?: Map<Urls, string>;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    loadingUrls: state.system.loadingUrls,
}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    render() {
        const { loadingUrls } = this.props;
        return (
            <div className={css.appManagement}>
                <Spin tip="正在努力为你加载中" spinning={loadingUrls.size > 0}>
                    <AppSearch />
                    <div style={{ minHeight: '580px'}}>
                        <AppList />
                    </div>
                    <div style={{clear: 'left'}}/>
                    <AppPages/>
                </Spin>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppManagement/UI.Components.tsx